import pb from './pb'

/**
 * Authenticated fetch wrapper — automatically adds PB auth token to all requests.
 * Use this instead of raw fetch() for any /api/* calls.
 *
 * On 401, clears the auth store and redirects to login.
 */
export async function apiFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const headers = new Headers(options.headers)

  if (!headers.has('Content-Type') && options.body) {
    headers.set('Content-Type', 'application/json')
  }

  if (pb.authStore.token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${pb.authStore.token}`)
  }

  const res = await fetch(url, { ...options, headers })

  if (res.status === 401) {
    pb.authStore.clear()
    window.location.href = '/login?expired=1'
  }

  return res
}
